import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "./UIForwardMessages.module.scss";

function UIForwardSkeleton() {
    return (
        <div className={styles.boxResultSearch}>
        <div className={styles.boxResultGroup}>
          <div className={styles.titleGroup}>
            <p style={{ fontWeight: "bold" }}>Group</p>
          </div>
          <div className={styles.itemGroup}>
            <div className={styles.groupItemSkel}>
                <Skeleton circle width={20} height={20} count={1} />
                <div className={styles.profileItem}>
                <Skeleton circle width={40} height={40} count={1} />
                </div>
                <div className={styles.itemName}>
                <Skeleton width={100} height={35} count={1} />
                </div>
            </div>
            <div className={styles.groupItemSkel} >
                <Skeleton circle width={20} height={20} count={1} />
                <div className={styles.profileItem}>
                <Skeleton circle width={40} height={40} count={1} />
                </div>
                <div className={styles.itemName}>
                <Skeleton width={120} height={35} count={1} />
                </div>
            </div>
          </div>
        </div>
        <div className={styles.boxResultFriends}>
          <div className={styles.titleFriends}>
            <p style={{ fontWeight: "bold" }}>Friends</p>
          </div>
          <div className={styles.titleFriends}>
          <div className={styles.groupItemSkel}>
                <Skeleton circle width={20} height={20} count={1} />
                <div className={styles.profileItem}>
                <Skeleton circle width={40} height={40} count={1} />
                </div>
                <div className={styles.itemName}>
                <Skeleton width={110} height={35} count={1} />
                </div>
            </div>
            <div className={styles.groupItemSkel}>
                <Skeleton circle width={20} height={20} count={1} />
                <div className={styles.profileItem}>
                <Skeleton circle width={40} height={40} count={1} />
                </div>
                <div className={styles.itemName}>
                <Skeleton width={150} height={35} count={1} />
                </div>
            </div>
            <div className={styles.groupItemSkel}>
                <Skeleton circle width={20} height={20} count={1} />
                <div className={styles.profileItem}>
                <Skeleton circle width={40} height={40} count={1} />
                </div>
                <div className={styles.itemName}>
                <Skeleton width={120} height={35} count={1} />
                </div>
            </div>
            <div className={styles.groupItemSkel}>
                <Skeleton circle width={20} height={20} count={1} />
                <div className={styles.profileItem}>
                <Skeleton circle width={40} height={40} count={1} />
                </div>
                <div className={styles.itemName}>
                <Skeleton width={170} height={35} count={1} />
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default React.memo(UIForwardSkeleton);